<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m10.78 17.99-1.79-.9L13.53 8H8V6h8v1.53zM24 12a12.01 12.01 0 1 0-12 12c6.62 0 12-5.38 12-12m-2 0a10.01 10.01 0 0 1-20 0 10.01 10.01 0 0 1 20 0"/></svg>
</template>
